export default __webpack_public_path__ + "static/franziska-hinkelmann-925459aee62192afa19c970403dcd62d.jpg";